
import jwtDecode from "jwt-decode"
import apiErrMixin from "@/mixins/api-err"
import { scrollToFirstError } from "@/utils/error"

export default apiErrMixin.extend({
  props: {
    isPage: { type: Boolean, default: false },
  },

  data: () => ({
    email: "",
    password: "",
    passwordConfirm: "",
    isLoading: false,
  }),

  computed: {
    step (): "complete" | "init" {
      return this.$route.query.token ? "complete" : "init"
    },

    label (): string {
      return this.$t("pages.auth.reset.form.password.label") as string
    },
    confirmLabel (): string {
      return this.$t("pages.auth.reset.form.passwordConfirm.label") as string
    },
  },

  methods: {
    async onSubmit () {
      if (this.isLoading) return

      const { validationObserver } = this.$refs
      if (!validationObserver) return
      const isValid = await (validationObserver as any).validate()
      if (!isValid) return scrollToFirstError()

      this.isLoading = true
      if (this.step === "init") await this.initRecovery()
      else await this.completeRecovery()
      this.isLoading = false
    },

    async initRecovery () {
      const [, err] = await this.$api.passwordRecovery
        .initPasswordRecovery(this.email)
      if (err) {
        this.apiErr = err.response.data
        await this.$nextTick()
        scrollToFirstError()
      } else {
        this.$notify({
          title: this.$t("message.success") as string,
          message: this.$t("message.passwordReset.message") as string,
          type: "success",
        })
        if (this.isPage) this.$router.push(this.localePath("/"))
        else this.$emit("close")
      }
    },

    async completeRecovery () {
      const token = this.$route.query.token as string
      const { password } = this
      const [, err] = await this.$api.passwordRecovery.changePassword({
        token,
        newPassword: password,
      })

      if (err) {
        this.apiErr = err.response.data
        await this.$nextTick()
        scrollToFirstError()
      } else {
        // Авторизуем сами
        const tokenData = jwtDecode(token) as any
        try {
          this.$auth.loginWith("local", {
            data: { username: tokenData?.data?.email, password },
          })
        } catch (e) { console.error(e) }

        this.$notify({
          title: "",
          message: this.$t("message.passwordReset.complete") as string,
          type: "success",
        })
        if (this.isPage) this.$router.push(this.localePath("/user/profile"))
        else this.$emit("close")
      }
    },
  },
})
